import styled from "@emotion/styled";
import { formInstructions } from "theme/styles/mixins";

export const NoAnalyticsMessage = styled.span`
  ${formInstructions}
  display: block;
`;
